Object.defineProperty(exports, "__esModule", { value: true });
exports.compileUnionType = void 0;
const graphql_1 = require("graphql");
const error_1 = require("./error");
const typeResolvers_1 = require("../../services/utils/gql/types/typeResolvers");
const compileUnionCache = new WeakMap();
function getDefaultResolver(types) {
    return (value, context, info) => {
        for (const type of types) {
            if (type.isTypeOf && type.isTypeOf(value, context, info)) {
                return type;
            }
        }
    };
}
/**
 * Resolves type, and if needed, tries to resolve it using decapi-aware types
 */
function enhanceTypeResolver(originalResolver) {
    return (value, context, info) => {
        const rawResolvedType = originalResolver(value, context, info);
        return typeResolvers_1.resolveType(rawResolvedType);
    };
}
function validateResolvedTypes(target, types) {
    for (const type of types) {
        if (!graphql_1.isObjectType(type)) {
            throw new error_1.UnionError(target, `Every union type must be of type GraphQLObjectType. '${type}' is not.`);
        }
    }
    return true;
}
function compileUnionType(target, config) {
    if (compileUnionCache.has(target)) {
        return compileUnionCache.get(target);
    }
    const { types, resolveTypes, name } = config;
    const resolvedTypes = typeResolvers_1.resolveTypesList(types);
    if (!validateResolvedTypes(target, resolvedTypes)) {
        return;
    }
    const typeResolver = resolveTypes
        ? enhanceTypeResolver(resolveTypes)
        : getDefaultResolver(resolvedTypes);
    const compiled = new graphql_1.GraphQLUnionType({
        name,
        resolveType: typeResolver,
        types: resolvedTypes
    });
    compileUnionCache.set(target, compiled);
    return compiled;
}
exports.compileUnionType = compileUnionType;
//# sourceMappingURL=compileUnionType.js.map